export const SUBCIRIPTION_TYPE = {
    Annual: 0,
    Monthly: 1
};
